import axios from '../../utils/axios'
import { getUser } from 'src/utils/Common';

export const getTasks = () => {
  const SessionUser = getUser();
  return axios.get(`/GetArtemisOpenServicePaper/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`);
};
